import { environment } from '../environments/environment';

export const getDriverPortalUrl =  () => {
    return environment.DRIVER_PORTAL_URL;
}

export const redirectToDriverPortal = () => {
    window.location.href = getDriverPortalUrl();
}
